import { TextRedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo } from "react";

/** Undefined until the saved setting loads, which the server applies meanwhile. */
export type BotClicksOverride = boolean | undefined;

const options: TextRedoListItem<boolean>[] = [
  { id: "include", type: "text", text: "Include bot clicks", value: true },
  { id: "exclude", type: "text", text: "Exclude bot clicks", value: false },
];

export const MarketingBotFilter = memo(function MarketingBotFilter({
  includeBotClicks,
  setIncludeBotClicks,
}: {
  includeBotClicks: BotClicksOverride;
  setIncludeBotClicks: (value: boolean) => void;
}) {
  return (
    <RedoSingleSelectDropdownInput<boolean>
      fitToAnchor={false}
      flexGrow={false}
      label="Bot clicks"
      options={options}
      optionSelected={({ item }) => setIncludeBotClicks(item.value)}
      selectedItem={options.find((option) => option.value === includeBotClicks)}
      size="xs"
    />
  );
});

/** Names a click measure that leaves bot clicks out, so it never renders under
 *  the plain label. */
export function clickBasisLabel(
  includeBotClicks: BotClicksOverride,
): "Human" | undefined {
  return includeBotClicks === false ? "Human" : undefined;
}

/** Why a human-only click measure is not on the same basis as sends. */
export function clickBasisExplanation(
  includeBotClicks: BotClicksOverride,
): string[] | undefined {
  return clickBasisLabel(includeBotClicks)
    ? [
        "Clicks not judged to come from a bot, over every message sent. A send carries no bot status, so the denominator is never filtered.",
      ]
    : undefined;
}
